function initTableFees(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".table-fees").forEach((bloc) => {
		const tabs = bloc.querySelectorAll("[data-fees-tab]");
		const panels = bloc.querySelectorAll("[data-fees-panel]");
		const buttons = bloc.querySelectorAll(".table-fees__payment .list-buttons-alt__button");

		if (!tabs.length) return;

		tabs.forEach((tab) => {
			tab.addEventListener("click", () => {
				const target = tab.dataset.feesTab;

				tabs.forEach((t) => t.classList.remove("is-active"));
				tab.classList.add("is-active");

				panels.forEach((p) => {
					p.classList.toggle("is-active", p.dataset.feesPanel === target);
				});
			});
		});

		buttons.forEach((btn) => {
			btn.addEventListener("click", () => {
				const index = btn.dataset.priceIndex;
				bloc.querySelectorAll(".table-fees__panel .variation-amount").forEach((amount) => {
					amount.textContent = amount.dataset["amount-" + index];
				});
			})
		});

	});

}

// Front-end
document.addEventListener("DOMContentLoaded", () => initTableFees());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-table-fees", ($block) => {
		initTableFees($block && $block.jquery ? $block.get(0) : $block);
	});
}
